import type { RGProduct } from "@raumagarn/formatters";
import Image from "next/image";
import styles from "./CartImage.module.css";

type ImageProps = {
	image: string;
	alt: string;
	type?: RGProduct["pr_product_type_type"];
};

export const CartImage = ({ image, alt, type }: ImageProps) => {
	if (type === "recipe" || type === "booklet") {
		return (
			<div className={styles["cart-image"]}>
				<Image src={image} alt={alt} objectFit="contain" width={55} height={78} />
			</div>
		);
	}
	return <Image src={image} alt={alt} width={80} height={100} objectFit="contain" />;
};
